import {
  initialState as commonsInitialState,
  commonsReducer,
} from './reducers/commons';
import {
  initialState as catalogsInitialState,
  reducer as catalogsReducer,
} from './reducers/catalogs';
import {
  initialState as giftTableInitialState,
  reducer as giftTableReducer,
} from './reducers/giftTable';
import {
  initialState as giftTableFlowInitialState,
  reducer as giftTableFlowReducer,
} from './reducers/giftTableFlow';
import {
  initialState as reviewsInitialState,
  reducer as reviewsReducer,
} from './reducers/reviews';
import {
  initialState as giftsInitialState,
  reducer as giftsReducer,
} from './reducers/gifts';
import {
  initialState as externalGiftTableInitialState,
  reducer as externalGiftTableReducer,
} from './reducers/externalGiftTable';
import {
  initialState as faqsState,
  reducer as faqsFAQsReducer,
} from './reducers/faqs';
import {
  initialState as paymentState,
  reducer as paymentReducer,
} from './reducers/payment';

export const initialState = {
  commons: commonsInitialState,
  catalogs: catalogsInitialState,
  giftTable: giftTableInitialState,
  giftTableFlow: giftTableFlowInitialState,
  reviews: reviewsInitialState,
  gifts: giftsInitialState,
  externalGiftTable: externalGiftTableInitialState,
  faqs: faqsState,
  payment: paymentState,
};

export const reducer = (state, action) => ({
  commons: commonsReducer(state.commons, action),
  catalogs: catalogsReducer(state.catalogs, action),
  giftTable: giftTableReducer(state.giftTable, action),
  giftTableFlow: giftTableFlowReducer(state.giftTableFlow, action),
  reviews: reviewsReducer(state.reviews, action),
  gifts: giftsReducer(state.gifts, action),
  externalGiftTable: externalGiftTableReducer(state.externalGiftTable, action),
  faqs: faqsFAQsReducer(state.faqs, action),
  payment: paymentReducer(state.payment, action),
});

export { default as useStore } from './useStore';
export { default as useDispatch } from './useDispatch';
export { default as withStore } from './withStore';
export { getState } from './helpers';
